"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripePriceIds = exports.PlanEnum = void 0;
var PlanEnum;
(function (PlanEnum) {
    PlanEnum["Free"] = "FREE";
    PlanEnum["Tier1"] = "TIER_1";
})(PlanEnum = exports.PlanEnum || (exports.PlanEnum = {}));
exports.StripePriceIds = {
    FREE: '',
    TIER_1: 'price_1JyNUCKZew7E5LVzazC8Ik5N'
};
